/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import {
  Box,
  Text,
  VStack,
  Button,
  HStack,
  useDisclosure,
  Flex,
  Spacer,
  Circle,
} from '@chakra-ui/react';
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import TrackUpdateModal from './update.track.component';
import { useWallet } from '@solana/wallet-adapter-react';
import { lordWallet } from '..';
import { getDisplayTimeBySeconds } from './player.component';
import PaidIcon from '@mui/icons-material/Paid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { log } from '../utils';

export default function Track(props) {
  const {
    isPlaying,
    track,
    onDeleteTrack,
    onStream,
    openq,
    tracks,
    currentTrackAddress,
    streamingqAddress,
  } = props;

  const [innerTrack, setTrack] = useState(track);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { publicKey } = useWallet();

  const [queue] = useState(openq);
  const [innerTracks] = useState(tracks);
  const [innerIsPlaying, setIsPlaying] = useState(false);

  const numberFormat = useMemo(() => new Intl.NumberFormat())

  const handlePlay = useCallback(() => {
    onStream(
      queue.queue_address,
      queue,
      !innerIsPlaying,
      queue.queue_address === streamingqAddress,
      innerTracks,
      innerTrack.track_address
    );
  }, [innerIsPlaying, queue, innerTracks, innerTrack, streamingqAddress]);

  const handleDelete = useCallback(() => {
    onDeleteTrack(innerTrack);
  }, [innerTrack]);

  const updateListener = useCallback(updatedTrack => {
    setTrack(updatedTrack);
  }, []);

  const isPaid = useCallback(
    () => Number.parseFloat(innerTrack.price) > 0,
    [innerTrack]
  );

  useEffect(() => {
    setIsPlaying(isPlaying && innerTrack.track_address === currentTrackAddress);
  }, [isPlaying, currentTrackAddress]);

  log({
    component: 'Track',
    msg: 'rendering track',
    isPlaying: isPlaying,
    innerIsPlaying:
      isPlaying && innerTrack.track_address === currentTrackAddress,
    innerIsPlaying: innerIsPlaying,
    currentTrackAddress: currentTrackAddress,
    props: { ...props },
  });

  return (
    <Flex
      p={3}
      borderRadius={'lg'}
      shadow={innerIsPlaying ? '2xl' : 'sm'}
      color={'white'}
      display="flex"
      fontSize={['small', 'medium']}
      overflow="hidden"
      marginTop={'8px'}
      marginBottom={'8px'}
    >
      <Box me={'2'} style={{ width: '50px', height: '50px' }}>
        <img
          src={
            innerTrack.art_uri ||
            `${process.env.PUBLIC_URL}/logo-512x512-bg.png`
          }
          alt="Artwork"
          style={{ width: '49px', height: '49px', borderRadius: '50%' }}
        />
        <Circle
          bg="gray.400"
          opacity={'0.2'}
          color={'white'}
          style={{
            zIndex: '1',
            position: 'relative',
            top: '-50px',
            left: '-1px',
            width: '50px',
            height: '50px',
          }}
        />
        <Button
          onClick={handlePlay}
          size={'xs'}
          bg={'transparent'}
          color={'white'}
          style={{
            zIndex: '2',
            position: 'relative',
            top: '-100px',
            left: '0',
            width: '50px',
            height: '50px',
          }}
        >
          <span class="material-icons md-48">
            {innerIsPlaying ? 'pause' : 'play_arrow'}
          </span>
        </Button>
      </Box>
      <VStack align={'start'} spacing={1}>
        <Text fontSize="sm" fontWeight={'bold'} noOfLines={1}>
          {innerTrack.title}
        </Text>
        <Text fontSize="xs" noOfLines={1}>
          {innerTrack.artist}
        </Text>
        <HStack spacing={[5, 10]}>
          <Text fontSize={'sm'}>
            {getDisplayTimeBySeconds(innerTrack.duration)}
          </Text>
          {isPaid() && (
            <Box color={'yellow.400'}>
              <PaidIcon />
            </Box>
          )}
          {!isPaid() && (
            <Text fontSize={'sm'} fontWeight={'light'}>
              {'Free'}
            </Text>
          )}
        </HStack>
      </VStack>
      <Spacer />
      <VStack>
      <Text fontWeight={"thin"} fontSize={"small"}>LoOps</Text>
      <Text fontWeight={"thin"} fontSize={"small"}>{numberFormat.format(track.loops)}</Text>
      </VStack>
      {publicKey &&
        (publicKey.toBase58() === innerTrack.owner_wallet_address ||
          publicKey.equals(lordWallet)) && (
          <Menu>
            <MenuButton>
              <MoreVertIcon />
            </MenuButton>
            <MenuList>
              <MenuItem onClick={onOpen} color={'gray.900'}>
                <EditIcon /> Edit
              </MenuItem>
              <MenuItem onClick={handleDelete} color={'gray.900'}>
                <DeleteIcon /> Delete
              </MenuItem>
            </MenuList>
          </Menu>
        )}
      <TrackUpdateModal
        track={innerTrack}
        isOpen={isOpen}
        onClose={onClose}
        onUpdateListener={updateListener}
      />
    </Flex>
  );
}
